import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { DatePipe, DOCUMENT } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild
} from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { ngxLightOptions } from "ngx-light-carousel";
import { SlickCarouselComponent } from "ngx-slick-carousel";
import { Observable, zip } from "rxjs";
import { environment } from "../../../../environments/environment";
import { AuthenticationService, NewsService } from "../../../core";
import {
  shareSocialMedia,
  SocialMediaProviders,
  textFromHtml
} from "../../../core/_helpers/share-helper";
import { Directions } from "../../../core/models/enums/direction.enum";
import { ImageSEO } from "../../../core/models/image-seo.model";
import { DemoDialogService } from "../../../core/services/dialog";
import { SiilaTranslationService } from "../../../core/services/siila-translation.service";
import { StaticImagesSEOService } from "../../../core/services/static-images.service";
import { MoreNews } from "../../models/more-news.model";
import { NewsTopics } from "../../models/news-topics.model";
import { ImageDTO, NewsDetail, NewsSection } from "../../models/news.model";
import { I18nService } from "../../services";
import { AnalyticsService } from "../../services/analytics.service";
import { MetaTagService } from "../../services/meta-tag.service";
import { NewsNavigateService } from "../../services/news.navigate.service";
import { action, page } from "../../utils/params";
import { DemoDialogComponent } from "../dialogs";

interface SocialMediaLinkOptions {
  title?: string;
  mailTo?: string;
  subject?: string;
  body?: string;
}

interface SocialMediaLink {
  alt: string;
  title: string;
  img: string;
  providerId: string;
  link: string;
  options: SocialMediaLinkOptions;
}

@Component({
  selector: "app-detail-news",
  templateUrl: "./detail-news.component.html",
  styleUrls: ["./detail-news.component.scss"]
})
export class DetailNewsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("mainDiv") mainDiv: ElementRef;
  @ViewChild("slickCarousel", { static: true })
  carousel: SlickCarouselComponent;
  currentCode: string = "";
  news: NewsDetail = new NewsDetail();
  mostRead: MoreNews[] = [];
  topics: NewsTopics[] = [];
  isExpanded: boolean = false;
  isMobile = false;
  idNews;
  sectionImages: ImageDTO[];
  currentIndex = 0;
  headerImgCaption: string;
  browserLang: string;

  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1
  };

  socialMediaLinks: SocialMediaLink[] = [];

  defaultSlide: Partial<ngxLightOptions>;
  siilaBrandSEO: ImageSEO;
  spotTransformingSEO: ImageSEO;
  siilaAcademyBannerSEO: ImageSEO;
  trustedUrl: SafeResourceUrl;
  unsafeUrl = "https://player.vimeo.com/video/822080532"; // Reemplaza con tu URL
  show = true;
  translatedPrimaryContent: string;
  public $isLoggedIn: Observable<boolean>;
  isPropertyType = false;
  userIsLoggedIn;
  bannerOod: ImageSEO;
  bannerPairs: ImageSEO;
  bannerAdvertisers: { slug: string; name: string }[] = [];
  marketAnalyticsSEO: ImageSEO;
  latamCountry = "latamBr";

  constructor(
    private newsService: NewsService,
    private i18: I18nService,
    private _cdr: ChangeDetectorRef,
    public breakpointObserver: BreakpointObserver,
    private route: ActivatedRoute,
    private siilaTranslationService: SiilaTranslationService,
    private datePipe: DatePipe,
    private metaSrv: MetaTagService,
    public sanitizer: DomSanitizer,
    private staticImgSrv: StaticImagesSEOService,
    private analyticsSrv: AnalyticsService,
    @Inject(DOCUMENT) private document: Document,
    private newsNavigate: NewsNavigateService,
    private demo: DemoDialogService,
    private auth: AuthenticationService
  ) {
    this.currentCode = environment.platformId;
    this.breakpointObserver
      .observe([Breakpoints.HandsetPortrait, Breakpoints.HandsetLandscape])
      .subscribe(result => {
        this.isMobile = result.matches;
      });

    this.defaultSlide = {
      arrows: true,
      infinite: false
    };

    this.browserLang = this.siilaTranslationService.getCurrentLanguage();
    this.trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.unsafeUrl
    );
    this.$isLoggedIn = this.auth.$isLoginSubject;
    this.$isLoggedIn.subscribe(isLoggedIn => {
      if (isLoggedIn) {
        this.userIsLoggedIn = true;
        let user = JSON.parse(localStorage.getItem("user"));
        this.newsService
          .getSubscription(user.companyId)
          .subscribe((resp: unknown[]) => {
            this.isPropertyType =
              resp.length > 0 && user?.roles?.includes("ROLE_USER");
          });
      } else {
        this.userIsLoggedIn = false;
      }
    });
  }
  ngAfterViewInit() {}

  ngOnDestroy() {
    // Leaving the article must not leak the restriction to other pages.
    this.newsService.setHideSpanishMenu(false);
  }

  ngOnInit() {
    this.setStorageBanner();
    this.bannerOod = this.staticImgSrv.getBannerOdd();
    this.bannerPairs = this.staticImgSrv.getBannerPairs();
    if (this.currentCode !== "co") {
      this.analyticsSrv.trackBannerImpression(
        this.bannerOod,
        1,
        this.currentCode
      );
      this.analyticsSrv.trackBannerImpression(
        this.bannerPairs,
        2,
        this.currentCode
      );
      this.bannerAdvertisers = [
        {
          slug: this.bannerOod?.advertiserSlug,
          name: this.bannerOod?.advertiserName
        },
        {
          slug: this.bannerPairs?.advertiserSlug,
          name: this.bannerPairs?.advertiserName
        }
      ].filter(a => !!a.slug);
    }
    this.marketAnalyticsSEO = this.staticImgSrv.getMultifamilySEO();
    const whatsappSEO = this.staticImgSrv.getShareWhatsappSEO();
    const shareEmailSEO = this.staticImgSrv.getShareEmailSEO();
    const facebookSEO = this.staticImgSrv.getShareFacebookSEO();
    const linkedSEO = this.staticImgSrv.getShareLinkedinSEO();
    this.socialMediaLinks = [
      {
        alt: whatsappSEO.alt,
        title: whatsappSEO.title,
        img: "../../../assets/icons/whatsapp.png",
        providerId: "whatsapp",
        link: this.document.location.href,
        options: {
          title: null
        }
      },
      {
        alt: shareEmailSEO.alt,
        title: shareEmailSEO.title,
        img: "../../../assets/icons/mail.png",
        providerId: "email",
        link: "mailto:",
        options: {
          mailTo: "",
          subject: null,
          body: null
        }
      },
      {
        alt: facebookSEO.alt,
        title: facebookSEO.title,
        img: "../../../assets/icons/facebook.png",
        providerId: "facebook",
        link:
          this.currentCode == "br"
            ? "https://web.facebook.com/SiiLA.BR/"
            : "https://www.facebook.com/SiiLA.mx",
        options: {
          title: null
        }
      },
      {
        alt: linkedSEO.alt,
        title: linkedSEO.title,
        img: "../../../assets/icons/in.png",
        providerId: "linkedin",
        link:
          this.currentCode == "br"
            ? "https://www.linkedin.com/company/siila-br"
            : "https://www.linkedin.com/company/siila-mx",
        options: {
          title: null
        }
      }
    ];
    this.siilaBrandSEO = this.staticImgSrv.getMultifamilySEO();
    this.spotTransformingSEO = this.staticImgSrv.getSpotTransformingExperienceSEO();
    this.siilaAcademyBannerSEO = this.staticImgSrv.getAcademyImgSEO();
    this.route.params.subscribe(params => {
      this.idNews = params.id;
      this.getNews();
      this.getTopics();
    });

    this.newsService.changesLang$.subscribe(val => {
      if (val) {
        this.browserLang = this.siilaTranslationService.getCurrentLanguage();
        this.openNews(
          this.news.id,
          this.siilaTranslationService.getTranslation(this.news.headline),
          true
        );
      }
    });

    setTimeout(() => {
      this.configureWistiaAutoplay();
    }, 2000);
  }

  configureWistiaAutoplay(): void {
    if (typeof (window as any).Wistia !== "undefined") {
      if (this.bannerOod?.type === "wistia" && this.bannerOod.wistiaId) {
        this.tryPlayWistiaVideo(this.bannerOod.wistiaId, 0);
      }

      if (this.bannerPairs?.type === "wistia" && this.bannerPairs.wistiaId) {
        this.tryPlayWistiaVideo(this.bannerPairs.wistiaId, 0);
      }
    } else {
      setTimeout(() => {
        this.configureWistiaAutoplay();
      }, 1000);
    }
  }

  tryPlayWistiaVideo(videoId: string, attempt: number): void {
    if (attempt >= 10) {
      return;
    }

    const wistia = (window as any).Wistia;
    const video = wistia.api(videoId);

    if (video) {
      video.mute();
      video.play();
      video.bind("end", () => {
        video.time(0);
        video.play();
      });
    } else {
      setTimeout(() => {
        this.tryPlayWistiaVideo(videoId, attempt + 1);
      }, 500);
    }
  }

  setStorageBanner() {
    const totalCycle = this.getBannerCycleLength();
    const current = Number(localStorage.getItem("bannerCount")) || 0;
    const next = (current % totalCycle) + 1;
    localStorage.setItem("bannerCount", next.toString());
  }

  private getBannerCycleLength(): number {
    const totalBanners = this.currentCode === "br" ? 5 : 6;
    return totalBanners * (totalBanners / 2);
  }

  getNews() {
    this.translatedPrimaryContent = "";
    // Clear any prior restriction before the new article resolves, so navigating
    // from a latam BR-news article to a non-BR one re-shows Spanish in the menu.
    this.newsService.setHideSpanishMenu(false);

    const isPreviewMode = window.location.href.includes(
      "insight-preview/detail"
    );

    zip(
      this.newsService.getNewsId(this.idNews),
      this.newsService.getMostNews()
    ).subscribe(resp => {
      this.news = resp[0] as NewsDetail;

      if (this.news) {
        if (this.news.status !== "PUBLISHED" && !isPreviewMode) {
          window.location.href = "/resource";
          return;
        }

        this.translatedPrimaryContent = this.siilaTranslationService.getTranslation(
          this.news.primaryContent
        );
      }
      // latam + BR news (regionOriginId 101) → hide Spanish in the language menu.
      this.newsService.setHideSpanishMenu(
        this.currentCode === "latam" && this.news?.regionOriginId === 101
      );
      this.validateURL();
      this.metaSrv.addCanonicalTag(window.location.href);
      this.news.sectionsInfo.map(x =>
        x.videoURL != null && x.videoURL != ""
          ? (x.videoURL = this.sanitizeUrl(x.videoURL))
          : ""
      );

      if (this.news.headerImageCaption) {
        this.headerImgCaption = this.siilaTranslationService.getTranslation(
          this.news.headerImageCaption
        );
      }
      if (this.news.sectionsInfo) {
        try {
          this.sectionImages = this.news.sectionsInfo.map(
            (ns: NewsSection) => ns.sectionImgsRES
          )[0];
        } catch (error) {}
      }
      this.metaSrv.setInsightsDetailTags(this.news);
      // Article-aware hreflang: build each language's URL from the translated
      // headline so the EN alternate uses /news/<en-title> and PT/ES use
      // /noticias/<title>. Independent of which slug alias the visitor arrived on.
      this.metaSrv.addHreflangTags(
        `news/${this.idNews}`,
        lang =>
          this.siilaTranslationService.buildNewsDetailPath(
            this.news.urlTitle ? this.news.urlTitle : this.news.headline,
            this.idNews,
            lang
          ),
        this.news.regionOriginId
      );
      this.mostRead = resp[1] as MoreNews[];
      setTimeout(() => {
        this.addBlanktoLinks();
      }, 1000);
    });
  }

  validateURL() {
    if (!this.idNews) {
      return;
    }
    // Rebuild the canonical URL from known parts instead of splicing fixed
    // segment indices. Index-splicing only worked for the `/<prefix>/<slug>/<id>`
    // shape and mangled `resource/detail`, `insights/detail`, etc. (it left the
    // real id + original slug dangling as extra trailing segments).
    const prefix =
      this.siilaTranslationService.getCurrentLanguage() == "en"
        ? "news"
        : "noticias";
    const slug = this.news.urlTitle
      ? this.refactorTitle(this.news.urlTitle)
      : this.refactorTitle(this.news.headline);
    // Preserve a trailing `/lang/<code>` suffix if the visitor arrived with one.
    // Restricted to real language codes so a title that slugifies to "lang"
    // (e.g. `/noticias/lang/532`) is not misread as a language suffix.
    const langMatch = window.location.pathname.match(
      /\/lang\/(en|es|pt-br|pt)\/?$/
    );
    const langSuffix = langMatch ? `/lang/${langMatch[1]}` : "";
    const url = `${window.location.origin}/${prefix}/${slug}/${this.idNews}${langSuffix}${window.location.search}`;
    history.pushState(null, url, url);
  }

  refactorTitle(title) {
    return this.siilaTranslationService
      .getTranslation(title)
      .toLowerCase()
      .replaceAll(/[ %?]/g, "-")
      .replaceAll(/['"()<>&\\\/]/g, "");
  }

  addBlanktoLinks() {
    const links = this.mainDiv.nativeElement.querySelectorAll("a");
    links.forEach(link => {
      link.setAttribute("target", "_blank");
    });
  }

  getTopics() {
    this.newsService.getNewsTopics().subscribe(resp => {
      this.topics = resp as NewsTopics[];
    });
  }

  headerImageNews(item: string, size = false): string {
    const url = item.replace("***", size ? "1280w" : "640w");
    return `${environment.cloudfrontURL}${url}`;
  }
  playButton(isExpanded: boolean) {
    this.isExpanded = !isExpanded;
  }

  openNews(id: number, title, reload = false) {
    this.newsNavigate.openNews(
      id,
      title.urlTitle ? title.urlTitle : title.headline,
      this.isMobile || reload,
      "",
      false,
      this.browserLang
    );
  }

  getTranslation(value: string) {
    const r = JSON.parse(value)[
      this.siilaTranslationService.getCurrentLanguage()
    ];
    return r;
  }

  getLanguage() {
    return this.siilaTranslationService.getCurrentLanguage();
  }

  formatDate(date, format) {
    return this.datePipe.transform(date, format);
  }

  openSite() {
    const currentLang = this.siilaTranslationService.getCurrentLanguage();
    window.open(
      this.currentCode == "br"
        ? this.siilaTranslationService.buildCrossCountryUrl(
            "br",
            "",
            currentLang
          )
        : this.siilaTranslationService.buildCrossCountryUrl(
            "mx",
            "",
            currentLang
          ),
      this.isMobile ? "_self" : "_blank"
    );
  }

  openLatam() {
    window.open(
      this.siilaTranslationService.buildCrossCountryUrl("latam", ""),
      this.isMobile ? "_self" : "_blank"
    );
  }

  goNewsTags(tag, color, type = "tag") {
    const basePath = `resource/${type}/${this.siilaTranslationService.getTranslation(
      tag.name
    )}/${tag.id}/${color}`;
    window.open(
      this.siilaTranslationService.buildLocalizedPath(basePath),
      this.isMobile ? "_self" : "_blank"
    );
  }

  goHome(latam = false) {
    window.open(
      latam
        ? this.siilaTranslationService.buildCrossCountryUrl(
            "latam",
            "/resource"
          )
        : this.siilaTranslationService.buildLocalizedPath("resource"),
      "_self"
    );
  }

  isLastImage(): boolean {
    return this.currentIndex === this.sectionImages.length - 1;
  }

  isFirstImage(): boolean {
    return this.currentIndex === 0;
  }

  nextImage(): void {
    if (!this.isLastImage()) {
      this.currentIndex++;
    }
  }

  prevImage(): void {
    if (!this.isFirstImage()) {
      this.currentIndex--;
    }
  }

  prevSlide(carousel: SlickCarouselComponent) {
    if (!carousel) {
      return;
    }
    carousel.slickPrev();
  }

  loadPage(direction: string, carousel: SlickCarouselComponent) {
    switch (direction) {
      case Directions.Next:
        const lastSlideActive = this.isLastImage();

        if (!lastSlideActive) {
          carousel.slickNext();
          this._cdr.detectChanges();
        } else if (lastSlideActive) {
          carousel.slickNext();
        } else {
          //this.appendPage(Directions.Next, carousel);
        }
        break;
      case Directions.Back:
        this.prevSlide(carousel);
        break;
    }
  }

  shareLink(socialLink) {
    /* const articleTitle = this.getDefaultTranslation(this.article.title);
    const content = this.getDefaultTranslation(this.article.content); */

    switch (socialLink.providerId) {
      case SocialMediaProviders.Facebook:
      case SocialMediaProviders.LinkedIn:
        socialLink.options.body = textFromHtml(this.getDefaultTranslation(""));
        socialLink.options.url = window.location.href;
        socialLink.options.title = this.getDefaultTranslation(
          this.news.headline
        );
        shareSocialMedia(socialLink);
        break;
      case SocialMediaProviders.Email:
        const subject = `SiiLA News: ${this.getDefaultTranslation(
          this.news.headline
        )}`;
        const body =
          textFromHtml(
            `${this.getDefaultTranslation(this.news.primaryContent)}`
          ).substring(0, 300) +
          textFromHtml(
            ` ...\n\n<br><br><a href="${window.location.href}">${window.location.href}</a>`
          );
        const mailtoUrl = `mailto:?subject=${encodeURIComponent(
          subject
        )}&body=${encodeURIComponent(body)}`;

        window.location.href = mailtoUrl;
        break;
      case SocialMediaProviders.Whatsapp:
        window.open(
          `https://api.whatsapp.com/send?text=${this.getDefaultTranslation(
            this.getDefaultTranslation(this.news.headline)
          )}%20${socialLink.link}`,
          "_blank"
        );
        break;
      default:
        break;
    }
  }

  getAltTxt(text: string) {
    return this.siilaTranslationService.getTranslation(text);
  }

  getDefaultTranslation(translationArtifact) {
    try {
      return this.siilaTranslationService.getTranslation(translationArtifact);
    } catch (e) {}
  }

  isEnglishLang() {
    return this.i18.getCurrentLanguage() === "en";
  }

  isBR() {
    return this.currentCode && this.currentCode.toLowerCase() === "br";
  }

  openSpot() {
    if (this.isBR()) {
      var url = this.isEnglishLang()
        ? "https://spot.siila.com.br/en"
        : "https://spot.siila.com.br/pt-br";
      window.open(url, this.isMobile ? "_self" : "_blank");
    } else {
      window.open(
        this.i18.buildLocalizedPath("/SPOT"),
        this.isMobile ? "_self" : "_blank"
      );
    }
  }

  openProduct() {
    window.open(
      this.i18.buildLocalizedPath("/marketanalytics"),
      this.isMobile ? "_self" : "_blank"
    );
  }

  openAcademy() {
    window.open(
      "https://mailchi.mp/siila/academy-advanced",
      this.isMobile ? "_self" : "_blank"
    );
  }

  openMultifamilyBanner() {
    let url = this.isEnglishLang()
      ? "https://mailchi.mp/siila.com.br/7gms21uue1"
      : "https://mailchi.mp/siila.com.br/multifamily";
    window.open(url, this.isMobile ? "_self" : "_blank");
  }

  sanitizeUrl(url): SafeResourceUrl {
    const trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);

    return trustedUrl;
  }

  isIOS(): boolean {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
  }

  openContactDialog() {
    this.demo.open(
      DemoDialogComponent,
      false,
      page.resource,
      action.requestDemo,
      "",
      this.i18.get(`analytics.${this.currentCode}.analytic-list.titleModal`)
    );
  }

  login() {
    if (this.currentCode == "latam") {
      const region = this.news.contentTags?.regionOrigin;
      const redirectURL =
        region == 102 ? environment.redirectURLmx : environment.redirectURL;

      window.open(`${redirectURL}?newscallback=${this.news.id}`, "_self");
    } else {
      window.open(
        `${environment.redirectURL}?newscallback=${this.news.id}`,
        "_self"
      );
    }
  }

  validateOtherTopics(topic) {
    if (topic == "OUTROS" || topic == "OTROS" || topic == "OTHER") {
      return false;
    }

    return true;
  }

  validateCarousel() {
    return (
      (!this.userIsLoggedIn &&
        (this.news?.subscriberOnly == null ||
          this.news?.subscriberOnly == false)) ||
      (this.userIsLoggedIn && this.isPropertyType)
    );
  }

  /**
   * @param  {} event
   */
  slickInit(event) {}

  logintest() {
    this.auth.$isLoginSubject.next(true);
  }

  openBanner(banner: ImageSEO, position: number): void {
    if (this.currentCode !== "co") {
      this.analyticsSrv.trackBannerClick(banner, position, this.currentCode);
    }
    let resolvedLink = banner.link;
    if (
      resolvedLink &&
      !resolvedLink.startsWith("http") &&
      !resolvedLink.startsWith("/")
    ) {
      resolvedLink = "https://" + resolvedLink;
    }
    window.open(resolvedLink, this.isMobile ? "_self" : "_blank");
  }

  onVideoLoaded(video: HTMLVideoElement): void {
    video.muted = true;

    const playPromise = video.play();
    if (playPromise && typeof playPromise.then === "function") {
      playPromise.catch(err => {
        console.warn("Autoplay blocked by the browser:", err);
      });
    }
  }
}
